var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "n-page",
    { attrs: { padding: "" } },
    [_c("club-member-header", { attrs: { member: _vm.member } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }